import { FC } from 'react';

import Checkbox from '@components/Checkbox';

import {
  MultiSelectionItemWrapper,
  ExtraFieldValueStyle,
  SubTitle,
  CheckboxLabel,
} from './MultiSelectionFilterStyle';
import { ListingFilterItemInterface } from './types';

interface IMultiSelectionItem {
  singleItemClassName?: string;
  item: ListingFilterItemInterface;
  subTitleKey: string;
  value?: boolean;
  onChange: (selected: boolean) => void;
  showExtraField?: boolean;
  showSubTitle?: boolean;
}

const MultiSelectionItem: FC<IMultiSelectionItem> = ({
  singleItemClassName,
  item,
  subTitleKey,
  value,
  onChange,
  showExtraField = false,
  showSubTitle = false,
}) => {
  const itemSubTitle = subTitleKey
    ? item?.[subTitleKey as keyof ListingFilterItemInterface]
    : null;
  return (
    <MultiSelectionItemWrapper className={singleItemClassName}>
      <Checkbox
        testid='checkbox'
        onChange={onChange}
        checked={value}
        value={value}
        mode='controlled'
      >
        <CheckboxLabel>
          {item.value}
          {showSubTitle && itemSubTitle ? (
            <SubTitle>{'(' + itemSubTitle + ')'}</SubTitle>
          ) : null}
        </CheckboxLabel>
      </Checkbox>
      {showExtraField && item.extra ? (
        <ExtraFieldValueStyle>{item.extra.value}</ExtraFieldValueStyle>
      ) : null}
    </MultiSelectionItemWrapper>
  );
};

export default MultiSelectionItem;
